import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { debugLogPages } from '../../app/helpers/debugHelper';
import { isPanelComboFromTableEnabled } from '../../app/helpers/semanticSearchConfigHelper';

import L3FilterTechnology from './L3FilterTechnology';
import L3FilterAlternative from './L3FilterAlternative';
import L3FilterExperience from './L3FilterExperience';
import L3FilterInnovation from './L3FilterInnovation';
import L3FilterAssistance from './L3FilterAssistance';
import L3FilterFinancial from './L3FilterFinancial';
import L3FilterRegulation from './L3FilterRegulation';
import L3FilterVision from './L3FilterVision';
import L3FilterDynamic from './L3FilterDynamic';

const L2LeftContainerFilter = (props) => {
  const { moduleSelected } = props;
  const configuration = useSelector((state) => state.configuration);
  const comboFromTable = isPanelComboFromTableEnabled(configuration);

  debugLogPages(':: L2LeftContainerFilter', props);

  const filterMap = useMemo(() => ({
    technology: L3FilterTechnology,
    alternative: L3FilterAlternative,
    experience: L3FilterExperience,
    innovation: L3FilterInnovation,
    assistance: L3FilterAssistance,
    financial: L3FilterFinancial,
    regulation: L3FilterRegulation,
    vision: L3FilterVision,
  }), []);

  if (comboFromTable) {
    return (
      <div className="animate__animated animate__fadeIn">
        <L3FilterDynamic {...props} />
      </div>
    );
  }

  const FilterComponent = filterMap[moduleSelected?.key];
  if (!FilterComponent) return null;

  return (
    <div className="animate__animated animate__fadeIn">
      <FilterComponent {...props} />
    </div>
  );
};

export default React.memo(L2LeftContainerFilter);
